<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
export default {
  components: { },
  computed: {},
  data() {
    return {};
  },
  props: {
    path: {
      type: String,
    },
  },
  methods: {
     async open(idOrder, path) {
      console.log(path)
      try {
        let res = await axios.get(
          `${baseApiUrl}/report?idOrder=${idOrder}&path=${path}`,
          {
            responseType: "blob",
          }
        );
        let blob = new Blob([res.data], { type: "application/pdf" });
        let url = window.URL.createObjectURL(blob);
        window.open(url);
      } catch (e) {
        console.log(e);
      }
    },
    async download(idOrder, path, corporateName) {
      try {
        let res = await axios.get(
          `${baseApiUrl}/report?idOrder=${idOrder}&path=${path}`,
          {
            responseType: "blob",
          }
        );
        let blob = new Blob([res.data], { type: "application/pdf" });
        let url = window.URL.createObjectURL(blob);
        const fileElement = document.createElement("a"); 
        fileElement.href = url;
        fileElement.download = corporateName; 
        fileElement.click(); 
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
